// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+lRPl","loader-icon":"Loader_loader-icon__P5qM3","inner":"Loader_inner__p3BGw","spin":"Loader_spin__E4RJ0"};